import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


const ModalListaAsesoresGerente = ( params : any ) => {


  const { show, handleClose, gerente } = params

  const [ lista_asesores, setListaAsesores ] = useState<any>([])
  const cargarListaAsesores = async()=>{
    try{
      let response : any = await RequestService.getEndPoint(`gerentes/lista_asesores/${gerente.uuid}`)
      setListaAsesores(response.data)
    }
    catch(e){
      toast.error('Problemas al intentar cargar la lista de asesores')
    }
  }


      React.useEffect(() => {
        cargarListaAsesores()
      }, []);

  return (
    <>
      <Modal show={show} dialogClassName="modal-lg" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Lista de Asesores</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <small>Gerente</small>
            <h5>{gerente.nombres} {gerente.paterno} {gerente.materno}</h5>
            <small>Sucursal</small>
            <h5>{gerente.idsucursal.nombre_sucursal}</h5>
          {
            // JSON.stringify(gerente)
          }

          {
            lista_asesores.length == 0 && (
                <div className="alert alert-warning" role="alert">
                  El Gerente no tiene asistentes asignados
                </div>
              )
          }


          {
            lista_asesores.length > 0 && (

                <>
                  {
                    // JSON.stringify(lista_asesores)
                  }

                  <small>Asesores</small>

                    <ol className="list-group list-group-numbered list-group-flush">
                      {
                        lista_asesores.map(asesor => 

                        <li key={ Math.random().toString(36).substr(2, 9) } className={ 'list-group-item d-flex justify-content-between align-items-start ' + ( asesor.activo ? '' : 'disabled' )}>
                          <div className="ms-2 me-auto">
                            <div className="fw-bold">{asesor.curp}</div>
                            {asesor.nombres} {asesor.paterno} {asesor.materno}
                          </div>
                          <span className="badge bg-primary rounded-pill"><i className="fa fa-user" /></span>
                        </li>

                          )
                      }
                    </ol>

                </>
              )
          }


        </Modal.Body>
      </Modal>
    </>
  );
}


export default ModalListaAsesoresGerente;